<template>
  <div class="notification">
    <v-snackbar v-model="notification.isVisible" :color="notification.color" right bottom multi-line>
      <span class="notification-message" v-html="notification.message"></span>
      <v-btn dark flat @click="hide">
        {{ $t('close') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NotificationComp',

  computed: {
    ...mapGetters([
      'notification'
    ])
  },

  methods: {
    hide () {
      this.notification.isVisible = false
    }
  }
}
</script>
